// 后台四个列表页共用的两个日期函数。
//
// 放在这里而不是某个页面里：页面 import 页面会让「谁依赖谁」变得没有方向，
// 而这两个函数与任何一页都无关。

/** ISO 时间戳取日期部分。null 显示破折号。 */
export const day = (iso: string | null): string => (iso ? iso.slice(0, 10) : '—');

/**
 * 相对时间，只到「天」。
 *
 * 后台看的是「这人还活着吗」，不是秒级精度 —— 精确到分钟只会让一列
 * 本该一眼扫过的文字变得需要逐个读。
 */
export function since(iso: string | null): string {
  if (!iso) return '从未';
  const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86_400_000);
  if (days <= 0) return '今天';
  if (days === 1) return '昨天';
  return `${days} 天前`;
}
